module.exports = __webpack_public_path__ + "static/img/20240912_3.b162253.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2024/20240912_3.png
// module id = nVap
// module chunks = 0